import { openTimesheetModal } from '../State/timesheetModal'

export default function(projectId) {
  return function(dispatch) {
    dispatch(openTimesheetModal({ projectId: projectId }))
  }
}
